<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <board :details="admissionDetailsBoard" />
    <div class="mt-4">
      <section-title
        has-line
        title="Historial de Resumen de Resultados de Servicios de Intervención"
      />
      <div v-if="!isNewFeaturesImprovementEnabled">
        <div
          v-for="(item, index) in history"
          :key="`history-item-${index}`"
          class="row bg-secondary-3 rounded ml-2 mr-0 p-3 mb-2"
        >
          <div class="col col-md-1 border-right d-flex align-items-center">
            <div class="color-black font-16 font-weight-bold">
              {{ item.statusName }}
            </div>
          </div>
          <div class="col col-md-2">
            <div class="color-gray-6 font-14 font-weight-normal">
              Fecha Creación:
            </div>
            <div class="color-black font-weight-normal">
              {{ item.createdDate | date }}
            </div>
          </div>
          <div class="col col-md-2">
            <div
              v-if="item.isSubmitted"
              class="color-gray-6 font-14 font-weight-normal"
            >
              Fecha Sometido:
            </div>
            <div v-if="item.isSubmitted" class="color-black font-weight-normal">
              {{ item.updatedDate | date }}
            </div>
          </div>
          <div
            class="col-12 col-md-7 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
          >
            <action-button
              v-if="item.isSubmitted"
              class="outline-success px-2"
              i="fas fa-file-search"
              text="Ver Resumen de Resultados"
              variant="outline-success"
              @click="goToResultsSummary(item.id)"
            />
          </div>
        </div>
      </div>

      <div v-else>
        <time-line class="mt-4">
          <div v-for="(item, index) in history" :key="`item-index-${index}`">
            <time-line-item class="custom-time-line rounded">
              <template #date>
                <div class="date-container">
                  <div class="color-black font-16 font-weight-bold fulldate">
                    {{ item.statusDate | date }}
                  </div>
                  <div class="color-black font-12 font-weight-normal hour">
                    {{ item.statusDate | hour }}
                  </div>
                </div>
              </template>
              <div class="row">
                <div
                  class="col-12 col-sm-2 gradient-border text-md-center text-sm-left p-3 order-2 order-md-0 order-sm-2 ml-4 ml-md-0 ml-sm-4 mt-n3 mt-md-0 mt-sm-n3"
                >
                  <div
                    class="color-gray-6 font-14 ml-n5 d-sm-none d-md-block font-weight-normal"
                  >
                    Estatus:
                  </div>
                  <!-- Estatus -->
                  <em
                    class="fa fa-circle font-12 mr-2"
                    :class="`color-${getColor(item.summaryStatusId)}`"
                  />
                  <span
                    class="color-black font-16 font-weight-bold text-status"
                  >
                    {{ item.summaryStatus }}
                  </span>
                </div>
                <!-- Fin Estatus -->
                <!-- Info -->
                <div class="col-6 p-3 pl-4 d-flex align-items-center pr-0">
                  <div class="col">
                    <div
                      class="color-gray-6 font-14 font-weight-normal label-text"
                    >
                      Usuario:
                    </div>
                    <div
                      class="color-black font-16 font-weight-bold label-value"
                    >
                      {{ item.statusUpdatedBy }}
                    </div>
                  </div>
                </div>
                <!-- Fin Info -->
                <!-- Boton -->
                <div
                  class="col-4 my-2 border-left d-flex justify-content-center align-items-center toggle-action"
                >
                  <action-button
                    class="outline-success px-2"
                    i="fas fa-file-search"
                    text="Ver Resumen de Resultados"
                    variant="outline-success"
                    @click="goToResultsSummary(item.id)"
                  />
                </div>
                <!-- Fin Boton -->
              </div>
            </time-line-item>
          </div>
        </time-line>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import { getServiceResultSummaryHistory } from '@/modules/referralManagement/api';
import { getStudentReferralAdmision } from '@/modules/shared/studentreferral.api';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import summaryStatus from '@/utils/constants/resultSummaryStatus.js';

export default {
  name: 'ResultsSummaryHistory',
  components: {
    PageHeader,
    Board,
    SectionTitle,
    ActionButton,
    TimeLine,
    TimeLineItem,
  },
  data() {
    return {
      history: [],
      admissionInfo: {},
    };
  },
  computed: {
    admissionId() {
      return Number(this.$route.params.admissionId);
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Historial de Resumen de Resultados',
        routes: [
          'Proveedor',
          'Manejo de Referido',
          'Resumen de Resultados',
          'Historial de Resumen de Resultados',
        ],
      };
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: this.goToResultsSummary,
        },
      ];
    },
    admissionDetailsBoard() {
      return [
        [
          {
            label: 'Estudiante:',
            icon: 'fas fa-address-book',
            data: `${this.admissionInfo.studentSieId} - ${this.admissionInfo.fullName}`,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Edad:',
            icon: 'fas fa-calendar-edit',
            data: `${this.admissionInfo.studentAge} años`,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Grado:',
            icon: 'fas fa-calendar-edit',
            data: this.admissionInfo.grade,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Impedimento:',
            icon: 'fas fa-ballot-check',
            data: this.admissionInfo.impediment,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Región:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.region,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Municipio:',
            icon: 'fas fa-map-marker-alt',
            data: this.admissionInfo.municipality,
            cols: 'col-12 col-md-3',
          },
          {
            label: 'Escuela:',
            icon: 'fas fa-graduation-cap',
            data: this.admissionInfo.place,
            cols: 'col-12 col-md-3',
          },
        ],
        [
          {
            label: 'Tipo de Servicio:',
            data: this.admissionInfo.disciplineName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Modalidad:',
            data: this.admissionInfo.modalityTypeName,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Frecuencia:',
            data: this.admissionInfo.frequency,
            cols: 'col-4 col-sm col-12 mt-3',
          },
          {
            label: 'Duración:',
            data: this.admissionInfo.duration,
            cols: 'col-4 col-sm col-12 mt-3',
          },
        ],
      ];
    },
    isNewFeaturesImprovementEnabled() {
      return this.$route.params.isNewFeaturesImprovementEnabled;
    },
    getColor() {
      return (status) => {
        switch (status) {
          case summaryStatus.New:
            return 'yellow';
          case summaryStatus.Amendment:
            return 'secondary-36';
          case summaryStatus.Submitted:
            return 'green-light';
          default:
            return '';
        }
      };
    },
  },
  async created() {
    await this.getAdmissionInfo();
    await this.getInterventionHistory();
  },
  methods: {
    async getAdmissionInfo() {
      const { data } = await getStudentReferralAdmision(this.admissionId);
      this.admissionInfo = { ...data };
    },
    async getInterventionHistory() {
      const { data } = await getServiceResultSummaryHistory({
        studentSieId: this.admissionInfo.studentSieId,
        studentServiceId: this.admissionInfo.studentServiceId,
        academicYearId: this.admissionInfo.academicYearId,
      });
      if (data?.length) {
        this.history = data.map((rs) => ({
          ...rs,
          statusName: rs.isSubmitted ? 'Sometido' : 'Actual',
        }));
      }
    },
    goToResultsSummary(interventionServiceResultSummaryId) {
      this.$router.push({
        name: 'resultsSummary',
        params: {
          admissionId: this.admissionId,
          interventionServiceResultSummaryId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-view__extended {
  background: transparent !important;
  &:hover {
    color: #2db782 !important;
  }
}

.gradient-border {
  box-shadow: 8px 0 3px -3px #efefef !important;
}

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: #fff !important;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #fafafa;
  }
}

@media only screen and (max-width: 768px) {
  .date-container {
    padding-right: -10px !important;
    .fulldate {
      font-size: 11px !important;
    }
    .hour {
      font-size: 8px !important;
    }
  }

  .text-description {
    font-size: 12px !important;
    margin-left: 15px;
  }

  .text-status {
    font-size: 12px !important;
  }

  .additional-panel {
    .label-text {
      font-size: 10px !important;
    }
    .label-value {
      font-size: 12px !important;
    }
  }

  .timeline__container {
    width: 106% !important;
    margin-right: 1px !important;
  }

  ::v-deep .custom-time-line {
    div:first-child {
      margin-right: 0px !important;
      padding-right: 0px !important;
    }
    .w-date-fixed {
      width: auto !important;
      .date-container {
        padding-right: 1px !important;
      }
    }
    .icon-absolute {
      left: -13px !important;
      top: 26px;
      .radius {
        font-size: 10px;
        height: 22px !important;
        width: 22px !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
      }
    }
    .timeline__content--inner {
      margin-left: -6px !important;
    }
  }

  .toggle-action {
    border-left: unset !important;
  }
  .gradient-border {
    box-shadow: unset !important;
  }
}
</style>
